import React from 'react';
import Hero from '../components/Hero';
import ProductCarousel from '../components/ProductCarousel';
import Features from '../components/Features';
// import AudienceTabs from '../components/AudienceTabs';

const Home = () => {
  return (
    <>
      <Hero />
      <Features />
       {/* <AudienceTabs /> */}
      <ProductCarousel />
    </>
  );
};

export default Home;